import { modelOptions, prop } from '@typegoose/typegoose';
import mongoose from 'mongoose';
import { AffectedDevice, ScoreBreakdown } from './riskManagement.common.model';

@modelOptions({
  schemaOptions: { collection: 'companyApplicationState' },
  options: { customName: 'companyApplicationState' },
})
export class CompanyApplicationStateModel {
  @prop({ required: true })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: true })
  fullApplicationName: string;

  @prop({ required: true, type: ScoreBreakdown })
  scoreBreakdown: ScoreBreakdown;

  @prop({ required: true, type: AffectedDevice })
  affectedDevices: Array<AffectedDevice>;
}
